import { makeStyles } from '@mui/styles'
import ExploreBg1 from "../../assets/svg/explore-bg-1.svg"

export const useStyles = makeStyles((theme) => {
    return {
        section: {
            backgroundImage: `url(${ExploreBg1})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
        },
        footerView: {
            background: theme.palette.blue[4],
            padding: theme.spacing(2, 4),
            "& p": {
                fontSize: "16px",
                color: theme.palette.common.white,
            }
        },
    };
});
